import _ from 'lodash'
import { UUID } from '@/plugins/common'

export default class Order {
  constructor (args = {}) {
    const defaults = {
      id: UUID.create(),
      columnId: '',
      orderType: 'asc',
      reportId: ''
    }
    _.defaults(this, args, defaults)
  }
}



// WEBPACK FOOTER //
// ./src/store/report/order.js